'use client'

import { useBIPageView } from '@/context/BISdkContext'
import { PropsWithChildren } from 'react'

export default function SearchPageWrapper({ children }: PropsWithChildren) {
  useBIPageView()

  return <main className="relative flex">{children}</main>
}
